<template>
    <div class="slide-menu box-shadow">
        <thumbnail :text="user.name" :font-size="16" style="padding: 30px 0"></thumbnail>
        <el-menu :default-active="menuActive" class="fixed-menu" mode="vertical" @open="openSubMenu"
                 :unique-opened="true" router>
            <template v-for="(item, index) in menus">
                <el-submenu v-if="item.list.length" :key="index" :index="getRoute(item.value, item.text)">
                    <template slot="title">
                        <i :class="getIcon(item.value)"></i>
                        <span class="folded-hide">{{ item.text }}</span>
                    </template>
                    <el-menu-item v-if="item.value==='/interview/1'" index="/interview/0" >所有面试</el-menu-item>
                    <template v-for="(sub, subIndex) in item.list">
                        <el-menu-item :index="getRoute(sub.value)" :key='subIndex'>{{ sub.text}}</el-menu-item>
                    </template>
                </el-submenu>
                <el-menu-item v-else :index="getRoute(item.value)" :key="index"><i
                        :class="getIcon(item.value)"></i><span>{{ item.text}}</span>
                </el-menu-item>
            </template>
        </el-menu>
    </div>
</template>
<script type="text/javascript">
    import Thumbnail from 'components/thumbnail'
    import routes from 'src/router/routes'

    const nameToUrl = {}
    const nameToIcon = {}

    routes.forEach((item, index) => {
        if (item.name) {
            nameToUrl[item.name] = item.path
            if (item.meta && item.meta.menuIcon) {
                nameToIcon[item.name] = item.meta.menuIcon
            }
        } else {
            console.log(item)
            console.warn(`请给路由“${item.path}”设置name的值`)
        }
    })

    console.log(nameToUrl)

    export default {
        data () {
            return {
                menuActive: this.getActiveMenu()
            }
        },
        computed: {
            menus () {
                return this.$store.state.app.menu
            },
            user () {
                return this.$store.state.user
            }
        },
        watch: {
            '$route' (to, from) {
                this.menuActive = this.getActiveMenu()
            }
        },
        methods: {
            getIcon (name) {
                if (name.indexOf('/interview/') > -1) {
                    name = 'interviewList'
                }
                return nameToIcon[name] || ''
            },
            getRoute (name, text = '') {
                if(text.indexOf('面试') > -1) {
                    return '/interview/0'
                }
                if (name.indexOf('/') > -1) {
                    return name
                }
                let nameArr = name.split('?')
                return (nameArr[1] ? nameToUrl[nameArr[0]] + '?' + nameArr[1] : nameToUrl[nameArr[0]]) || ''
            },
            getActiveMenu () {
                let route = this.$route
                if (route.meta.oneToMore === true) {
                    return route.path
                }
                return this.getRoute(route.meta.activeMenuItem || route.name)
            },
            openSubMenu (index, indexPath) {
                this.$router.push({path: index})
            }
        },
        components: {
            Thumbnail
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";
    @import "~style/base/mixin";

    .slide-menu-wrap {
        @include transition;
        width    : $main-menu-width;
        position : fixed;
        z-index  : 10;
        left     : 0;
        height   : 100%;
        * {
            @include transition;
        }
    }

    .fixed-menu {
        overflow       : auto;
        position       : fixed;
        top            : 175px + $main-header-height;
        bottom         : 0;
        width          : $main-menu-width;
        left           : 0;
        padding-bottom : 20px;

        &::-webkit-scrollbar {
            width  : 6px;
            height : 6px;
        }

        /* 设置滚动条的滑轨 */
        &::-webkit-scrollbar-track {
            background-color : #eee;
        }

        /* 滑块 */
        &::-webkit-scrollbar-thumb {
            background-color : rgba(0, 0, 0, 0.2);
            border-radius    : 6px;
        }

        /* 滑轨两头的监听按钮 */
        &::-webkit-scrollbar-button {
            display : none;
        }
    }

    .page-right-content {
        position : absolute;
        left     : $main-menu-width;
        top      : 0;
        bottom   : 0;
        right    : 0;
        width    : auto;
        @include transition;
    }

    .fixed-bar {
        .container {
            padding-left : $main-menu-width;
            @include transition;
        }
    }

    .page-main.folded {
        .main-title {
            width            : $main-menu-mini-width;
            background-image : url('~images/logo.png');
        }
        .el-menu.fixed-menu {
            width      : 60px;
            overflow-x : hidden;
        }
        .folded-hide {
            opacity : 0;
        }
        .el-icon-arrow-down {
            opacity          : 0;
            transition-delay : 0.4s;
        }
        .el-submenu {
            > .el-menu {
                opacity : 0;
                height  : 0;
            }
        }
        .slide-menu-wrap {
            width : $main-menu-mini-width;
            .thumbnail-wrap {
                opacity : 0;
            }
            .el-menu-item {
                > span {
                    display : none;
                }
            }
        }
        .page-right-content {
            left : $main-menu-mini-width;
        }
        .fixed-bar {
            .container {
                padding-left : $main-menu-mini-width;
            }
        }
    }

    .page-main-content {
        position : absolute;
        width    : 100%;
        top      : $main-header-height;
        bottom   : 0;
    }

    .slide-menu {
        box-sizing : border-box;
        min-height : 100%;
        background : $background-color;
        .el-menu {
            background : transparent;
        }
        .el-menu-item {
            font-size   : 15px;
            height      : 36px;
            line-height : 36px;
            margin      : 20px 0;
            border-left : 4px solid transparent;
            &.is-active {
                border-color : $color-primary;
                background   : #f3f4f6;
            }
        }

        .el-submenu {
            .el-submenu__title {
                font-size   : 15px;
                height      : 36px;
                line-height : 36px;
                margin-top  : 20px;
                border-left : 4px solid transparent;
            }
            .el-menu-item {
                margin       : 10px 0;
                border-color : transparent;
                background   : white;
            }
            &.is-active {
                .el-submenu__title {
                    border-color : $color-primary;
                    background   : #f3f4f6;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// menu.vue?27656e18